(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var calendar = document.getElementById("calendar-table");
var gridTable = document.getElementById("table-body");
var currentDate = new Date();
var selectedDate = currentDate;
var selectedDayBlock = null;
var globalEventObj = {};
var bookingNewCalendarForm = document.getElementById('reduca-booking-new-calendar-form');
var intervals = JSON.parse(document.getElementById("rbncalendar").getAttribute("data-intervals"));
var bookedTimesRaw = JSON.parse(document.getElementById("rbncalendar").getAttribute("data-booked-times"));
var bookedTimes = bookedTimesRaw.map(function (x) {
  return x.replace('&', ' ');
});
var dayBins = getDayBins(bookedTimes);

function getDayBins(bookedTimes) {
  dayBins = {};

  var _iterator = _createForOfIteratorHelper(bookedTimes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var bt = _step.value;
      var date = bt.split(" ")[0];
      var time = bt.split(" ")[1];

      if (!dayBins[date]) {
        dayBins[date] = [];
      }

      dayBins[date].push(time);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return dayBins;
}

var add_zero = function add_zero(n) {
  return n < 10 ? '0' + n : '' + n;
};

function createCalendar(date, side) {
  var currentDate = date;
  var startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  var monthTitle = document.getElementById("month-name");
  var monthName = currentDate.toLocaleString("sv", {
    month: "long"
  });
  monthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
  var yearNum = currentDate.toLocaleString("sv", {
    year: "numeric"
  });
  monthTitle.innerHTML = "".concat(monthName, " ").concat(yearNum);

  if (side == "left") {
    gridTable.className = "animated fadeOutRight";
  } else {
    gridTable.className = "animated fadeOutLeft";
  }

  setTimeout(function () {
    gridTable.innerHTML = "";
    var newTr = document.createElement("div");
    newTr.className = "row";
    var currentTr = gridTable.appendChild(newTr);
    var firstDay = startDate.getDay();
    firstDay = firstDay === 0 ? 7 : firstDay;

    for (var i = 1; i < firstDay; i++) {
      var emptyDivCol = document.createElement("div");
      emptyDivCol.className = "col empty-day";
      currentTr.appendChild(emptyDivCol);
    }

    var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    lastDay = lastDay.getDate();

    var _loop = function _loop(_i) {
      if (currentTr.children.length >= 7) {
        currentTr = gridTable.appendChild(addNewRow());
      }

      var currentDay = document.createElement("div");
      currentDay.className = "col";

      if (selectedDayBlock == null && _i == currentDate.getDate() || selectedDate.toDateString() == new Date(currentDate.getFullYear(), currentDate.getMonth(), _i).toDateString()) {
        selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), _i);
        selectedDayBlock = currentDay;
        setTimeout(function () {
          currentDay.classList.add("blue");
          currentDay.classList.add("lighten-3");
          addSelectOptions();
        }, 900);
      }

      currentDay.innerHTML = _i; //show marks

      var currentDayBookings = dayBins[currentDate.getFullYear() + '/' + add_zero(currentDate.getMonth() + 1) + '/' + add_zero(_i)];
      var eventMark = document.createElement("span");
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      var day = new Date(currentDate.getFullYear(), currentDate.getMonth(), _i);

      if (day.getTime() < now.getTime()) {
        currentDay.style.pointerEvents = "none";
      } else if (Array.isArray(currentDayBookings) && currentDayBookings.length && intervals.length <= currentDayBookings.length) {
        eventMark.className = "day-mark-red";
        currentDay.appendChild(eventMark);
      } else if (Array.isArray(currentDayBookings) && currentDayBookings.length && intervals.length > currentDayBookings.length) {
        eventMark.className = "day-mark-orange";
        currentDay.appendChild(eventMark);
      } else {
        eventMark.className = "day-mark-green";
        currentDay.appendChild(eventMark);
      }

      currentTr.appendChild(currentDay);
    };

    for (var _i = 1; _i <= lastDay; _i++) {
      _loop(_i);
    }

    for (var _i2 = currentTr.getElementsByTagName("div").length; _i2 < 7; _i2++) {
      var _emptyDivCol = document.createElement("div");

      _emptyDivCol.className = "col empty-day";
      currentTr.appendChild(_emptyDivCol);
    }

    if (side == "left") {
      gridTable.className = "animated fadeInLeft";
    } else {
      gridTable.className = "animated fadeInRight";
    }

    function addNewRow() {
      var node = document.createElement("div");
      node.className = "row";
      return node;
    }
  }, !side ? 0 : 270);
}

createCalendar(currentDate);
var todayDayName = document.getElementById("todayDayName");
todayDayName.innerHTML = "Idag är " + currentDate.toLocaleString("sv", {
  weekday: "long",
  day: "numeric",
  month: "short"
});
var prevButton = document.getElementById("prev");
var nextButton = document.getElementById("next");

prevButton.onclick = function changeMonthPrev() {
  currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
  createCalendar(currentDate, "left");
};

nextButton.onclick = function changeMonthNext() {
  currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
  createCalendar(currentDate, "right");
};

function addEvent(name, email, time, phone_number, apartment_number, message, selected_time, selected_date) {
  if (!globalEventObj[selectedDate.toDateString()]) {
    globalEventObj[selectedDate.toDateString()] = {};
  }

  globalEventObj[selectedDate.toDateString()][name] = [email, time, phone_number, apartment_number, message]; // ajax http post request

  var url = bookingNewCalendarForm.dataset.url;
  var form = new FormData();
  form.append('name', name);
  form.append('email', email);
  form.append('booked_time', time);
  form.append('phone_number', phone_number);
  form.append('apartment_number', apartment_number);
  form.append('message', message);
  form.append('action', document.getElementById('reduca_action').value.trim());
  form.append('post_type', document.getElementById('post_type').value.trim());
  form.append('nonce', document.getElementById('reduca_nonce').value.trim()); //the following approach is not used as it is not supported by IE
  // let form = new FormData(bookingNewCalendarForm);
  // form.set('booked_time', time);

  var params = new URLSearchParams(form);
  bookingNewCalendarForm.querySelector('.js-form-submission').classList.add('show');
  fetch(url, {
    method: "POST",
    body: params
  }).then(function (res) {
    return res.json();
  }).catch(function (error) {
    resetMessages();
    bookingNewCalendarForm.querySelector('.js-form-error').classList.add('show');
  }).then(function (response) {
    resetMessages();

    if (response.status === 'ebe') {
      bookingNewCalendarForm.querySelector('.js-form-ebe').classList.add('show');
      return;
    }

    if (response === 0 || response.status.includes('error')) {
      bookingNewCalendarForm.querySelector('.js-form-error').classList.add('show');
      return;
    }

    bookingNewCalendarForm.querySelector('.js-form-success').classList.add('show');
    bookingNewCalendarForm.reset();
    addSelectOptions(selected_time);
    (dayBins[selected_date] || (dayBins[selected_date] = [])).push(selected_time);
    addForm.style.top = "100%";
  });
}

function resetMessages() {
  document.querySelectorAll('.field-msg').forEach(function (f) {
    return f.classList.remove('show');
  });
}

function showEvents() {
  // let sidebarEvents = document.getElementById("sidebarEvents");
  var objWithDate = globalEventObj[selectedDate.toDateString()]; // sidebarEvents.innerHTML = "";

  if (objWithDate) {
    var eventsCount = 0;

    for (var key in globalEventObj[selectedDate.toDateString()]) {
      eventsCount++;
    }

    var emptyFormMessage = document.getElementById("emptyFormTitle"); // emptyFormMessage.innerHTML = `${eventsCount} bokningar nu`;

    emptyFormMessage.innerHTML = "Tack för din bokning.";
  } else {}
}

gridTable.onclick = function (e) {
  if (!e.target.classList.contains("col") || e.target.classList.contains("empty-day")) {
    return;
  }

  if (selectedDayBlock) {
    if (selectedDayBlock.classList.contains("blue") && selectedDayBlock.classList.contains("lighten-3")) {
      selectedDayBlock.classList.remove("blue");
      selectedDayBlock.classList.remove("lighten-3");
    }
  }

  selectedDayBlock = e.target;
  selectedDayBlock.classList.add("blue");
  selectedDayBlock.classList.add("lighten-3");
  selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), parseInt(e.target.innerHTML));
  addSelectOptions();
  showEvents();
};

function addSelectOptions() {
  var just_booked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var selectElement = document.getElementById('booked_time');
  var intervals_formatted = getIntervalsFormatArr();
  var booked_times = dayBins[selectedDate.getFullYear() + '/' + add_zero(selectedDate.getMonth() + 1) + '/' + add_zero(selectedDate.getDate())];

  while (selectElement.options.length > 1) {
    selectElement.remove(selectElement.options.length - 1);
  }

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  if (selectedDate.getTime() < today.getTime()) {
    return;
  }

  if (Array.isArray(booked_times)) {
    var _iterator2 = _createForOfIteratorHelper(booked_times),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var bt = _step2.value;
        var idx = intervals_formatted.indexOf(bt);

        if (idx !== -1) {
          intervals_formatted.splice(idx, 1);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  intervals_formatted = intervals_formatted.filter(function (e) {
    return e !== just_booked;
  });

  if (selectedDate.getTime() === today.getTime()) {
    var now = new Date();
    var currentHour = now.getHours();

    var _iterator3 = _createForOfIteratorHelper(intervals_formatted),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var interval = _step3.value;

        if (currentHour < interval.split(":")[0]) {
          selectElement.add(new Option(interval));
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return;
  }

  var _iterator4 = _createForOfIteratorHelper(intervals_formatted),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _interval = _step4.value;
      selectElement.add(new Option(_interval));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}

function getIntervalsFormatArr() {
  var intervals_formated = [];

  var _iterator5 = _createForOfIteratorHelper(intervals),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var interval = _step5.value;
      var intvrl = add_zero(interval[0]) + ':00-' + add_zero(interval[1]) + ':00';
      intervals_formated.push(intvrl);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return intervals_formated;
}

var changeFormButton = document.getElementById("changeFormButton");
var addForm = document.getElementById("addForm");

changeFormButton.onclick = function (e) {
  addForm.style.top = 0;
};

var cancelAdd = document.getElementById("cancelAdd");

cancelAdd.onclick = function (e) {
  addForm.style.top = "100%";
  var inputs = addForm.getElementsByTagName("input");

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].value = "";
    inputs[i].style.borderColor = "";
  }
};

var addEventButton = document.getElementById("addEventButton");

addEventButton.onclick = function (e) {
  var name = document.getElementById("name").value.trim();
  var email = document.getElementById("email").value.trim();
  var selected_time = document.getElementById("booked_time").value.trim();
  var selected_date = selectedDate.getFullYear() + '/' + add_zero(selectedDate.getMonth() + 1) + '/' + add_zero(selectedDate.getDate());
  var time = selected_date + ' ' + selected_time;
  var phone_number = document.getElementById("phone_number").value.trim();
  var apartment_number = document.getElementById("apartment_number").value.trim();
  var message = document.getElementById("message").value.trim();
  var inputs = addForm.getElementsByTagName("input");

  for (var i = 0; i < inputs.length; i++) {
    inputs[i].style.borderColor = "";
  } // validate everything


  if (!name) {
    document.getElementById("name").style.borderColor = '#FF0000';
    return;
  }

  if (!validateEmail(email)) {
    document.getElementById("email").style.borderColor = '#FF0000';
    return;
  }

  if (!time) {
    document.getElementById("booked_time").style.borderColor = '#FF0000';
    return;
  }

  if (!phone_number) {
    document.getElementById("phone_number").style.borderColor = '#FF0000';
    return;
  }

  if (!apartment_number) {
    document.getElementById("apartment_number").style.borderColor = '#FF0000';
    return;
  }

  if (!message) {
    // document.getElementById("message").style.borderColor = '#FF0000';
    // return;
    message = "-";
  }

  if (!selected_time) {
    document.getElementById("booked_time").style.borderColor = '#FF0000';
    return;
  }

  addEvent(name, email, time, phone_number, apartment_number, message, selected_time, selected_date);
  showEvents();

  if (!selectedDayBlock.querySelector(".day-mark")) {
    selectedDayBlock.appendChild(document.createElement("div")).className = "day-mark";
  }

  for (var _i3 = 0; _i3 < inputs.length; _i3++) {
    inputs[_i3].value = "";
  }
};

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

},{}]},{},[1]);
